import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1.657 13.286V6.943L8 11.17l6.343-4.228v6.343c0 .584-.473 1.057-1.057 1.057H2.714a1.057 1.057 0 0 1-1.057-1.057ZM5.886 4.3h4.228M5.886 6.943h4.228M3.243 5.886v-3.7c0-.292.236-.529.528-.529h8.457c.292 0 .53.237.53.529v3.7",
  stroke: "#007F8F",
  "stroke-width": "1.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }